var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "154.75px",
    height: "89px",
    viewBox: "0 0 154.75 89",
    enableBackground: "new 0 0 154.75 89",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007676",
    d: "M90.269,44.911c0,7.328-5.146,12.824-11.514,12.824c-6.369,0-11.513-5.757-11.513-12.824 c0-6.978,5.145-12.647,11.513-12.647C85.122,32.264,90.269,37.672,90.269,44.911 M101.782,44.911 c0-13.258-9.594-23.376-21.371-23.376c-5.407,0-10.205,2.18-13.693,5.758v-4.711H55.64v64.896h11.602V63.143 c3.402,3.315,8.024,5.321,13.169,5.321C92.188,68.464,101.782,58.26,101.782,44.911"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007676",
    d: "M142.507,45.198c0,6.979-5.146,12.646-11.514,12.646s-11.514-5.494-11.514-12.646 c0-7.327,5.146-12.91,11.514-12.91S142.507,38.046,142.507,45.198 M154.021,0h-11.514v26.881c-3.488-3.314-8.025-5.234-13.258-5.234 c-11.689,0-21.371,10.118-21.371,23.464c0,13.259,9.682,23.377,21.371,23.377c5.494,0,10.205-2.093,13.781-5.756v4.797h10.99V0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#669BA2",
    d: "M35.628,45.198c0,6.979-5.146,12.646-11.514,12.646s-11.514-5.494-11.514-12.646 c0-7.327,5.146-12.91,11.514-12.91S35.628,38.046,35.628,45.198 M47.142,22.605h-10.99v4.799 c-3.489-3.665-8.287-5.758-13.782-5.758C10.681,21.646,1,31.765,1,45.11c0,13.259,9.681,23.377,21.37,23.377 c5.495,0,10.293-2.093,13.782-5.756v4.797h10.99V22.605z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ea80bbcf1ad480b90824e437344f3e89.svg";
export { ForwardRef as ReactComponent };